import React from "react";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";

const LeadershipSection = () => {
  const leaders = [
    {
      name: "Mrs. Flora Njura Kanyua",
      position: "Chief Principal",
      message:
        "Welcome to Karumo Technical Training Institute, where Creativity and Innovation deliver Solutions! As Principal, I lead a vibrant community of staff and trainees with a vision for excellence, and innovation. We are dedicated to equipping you with practical skills for a competitive world. At Karumo TTI, we are more than an institution; we are a launchpad for your dreams. Our goal is to transform ambition into achievement.",
      image:
        "assets/Principal.jpg",
    },
    {
      name: "Mr. Mathews Nkarichia",
      position: "Deputy Principal Administration",
      message: "We manage the backbone of our institution, overseeing operations, facilities, staff coordination, and resource allocation to ensure a thriving learning environment. Committed to efficiency and excellence, we support trainees, staff, and stakeholders with dedication. Our staff and trainees work tirelessly to maintain a safe, organized, and dynamic environment that fosters both learning and innovation.",
      image:
        "assets/Mathews.jpg",
    },
    {
      name: "Mrs. Alice Mugaa",
      position: "Deputy Principal Academics",
      message: "At Karumo Technical Training Institute, we are committed to equipping our students with practical skills, industry-relevant knowledge, and a strong foundation for lifelong learning. With our highly qualified trainers, well-equipped labs, and a learner-centered approach, we strive to provide a transformative educational experience.",
      image:
        "assets/Alice.jpg",
    },
    {
      name: "Naomi Njeri",
      position: "Registrar",
      message: "Join Karumo TTI today! Enjoy smooth admissions and accurate records that pave the way to a thriving career in technical excellence.",
      image:
        "assets/images/registrar.jpg",
    },
    {
      name: "Joseph Mithika",
      position: "Dean of Students",
      message: "Experience vibrant student life at Karumo TTI! Discover growth opportunities, exciting activities, and resources to unlock your full potential.",
      image:
        "assets/images/dean.jpg",
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-blue-700 to-yellow-500">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-yellow-600 mb-4">
            Management Team
          </h2>
          <p className="text-xl text-white max-w-3xl mx-auto">
            Meet the visionary leaders driving excellence in technical education
            and shaping the future of our students
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {leaders?.map((leader, index) => (
            <div
              key={index}
              className="bg-card rounded-2xl p-8 shadow-card-lg border border-border hover:shadow-xl transition-shadow duration-300"
            >
              {/* Profile Image */}
              <div className="text-center mb-6">
                <div className="relative inline-block">
                  <Image
                    src={leader?.image}
                    alt={leader?.name}
                    className="w-32 h-32 rounded-full object-cover mx-auto border-4 border-primary/20"
                  />
                  <div className="absolute -bottom-2 -right-2 w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                    <Icon name="Award" size={20} color="white" />
                  </div>
                </div>
              </div>

              {/* Basic Info */}
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-foreground mb-2">
                  {leader?.name}
                </h3>
                <p className="text-primary text-xl font-semibold mb-2">
                  {leader?.position}
                </p>
                <p className="text-l text-justify text-black mb-1">
                  {leader?.message}
                </p>
              </div>

            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LeadershipSection;
